<script lang="ts">
    import { getAllowedTaskTypes } from "../../../../api/hooks/config-client"
    import { login } from "../store"
    import Select from "../taskSteps/inputfields/Select.svelte"
    import Calendar from "./formComponents/Calendar.svelte"
    import Input from "./formComponents/Input.svelte"

    export let filter: OrderFilterT

    let copiedFilter = { ...filter }
    // update filter object whenever copiedFilter and filter actually differ:
    $: if (JSON.stringify(copiedFilter) !== JSON.stringify(filter)) {
        filter = { ...copiedFilter }
    }

    const taskTypes = getAllowedTaskTypes($login.user)
    const selectOptions: { value: any; label: any }[] = []
    if (taskTypes.includes("oilSpillRemoval")) {
        selectOptions.push({
            value: "oilSpillRemoval",
            label: "Ölspurbeseitigung",
        })
    }
    if (taskTypes.includes("towing")) {
        selectOptions.push({
            value: "towing",
            label: "Abschleppen",
        })
    }
    if (taskTypes.length == 2) {
        selectOptions.unshift({
            value: "all",
            label: "Alle",
        })
    }
    const orderStatusOptions = [
        {
            value: "all",
            label: "Alle",
        },
        {
            value: "open",
            label: "Offen",
        },
        {
            value: "inProgress",
            label: "In Bearbeitung",
        },
        {
            value: "completed",
            label: "Abgeschlossen",
        },
        {
            value: "billed",
            label: "Abgerechnet",
        },
        $login.user.roles.includes("admin")
            ? {
                  value: "canceled",
                  label: "Storniert",
              }
            : void 0,
    ].filter(Boolean)
</script>

<div
    class="filter-row form"
    style="padding-top: 0.6rem;"
>
    <div>
        <Select
            field="{{
                widget: 'select',
                label: 'Status',
                options: orderStatusOptions,
            }}"
            bind:value="{copiedFilter.status}"
        />
    </div>
    <div>
        <Select
            field="{{
                widget: 'select',
                label: 'Einsatzart',
                options: selectOptions,
            }}"
            bind:value="{copiedFilter.taskType}"
        />
    </div>
    <div>
        <Select
            field="{{
                widget: 'select',
                label: 'Zuständigkeit',
                options: [
                    {
                        value: 'me',
                        label: 'Ich (Nur mir zugewiesene Einsätze)',
                    },
                    {
                        value: 'all',
                        label: 'Alle (Niemanden zugewiesene Einsätze)',
                    },
                    {
                        value: 'unfiltered',
                        label: 'Ungefiltert (Alle Einsätze, Zuweisungsstatus unerheblich)',
                    },
                ],
            }}"
            bind:value="{copiedFilter.responsiblePerson}"
        />
    </div>
</div>

<div class="filter-row form">
    <div style="display: flex; gap: 0.5rem;">
        <Calendar
            placeholder="Datum / Datum von"
            id="Date-order"
            bind:dateValue="{copiedFilter.date}"
            editMode="{true}"
            hideTime="{true}"
        />
    </div>
    <div style="display: flex; gap: 0.5rem;">
        <Calendar
            placeholder="Datum bis"
            id="Date-order"
            bind:dateValue="{copiedFilter.date2}"
            editMode="{true}"
            hideTime="{true}"
        />
    </div>
    <div>
        <Input
            placeholder="Suche"
            id="search"
            value="{copiedFilter.textSearch}"
            onBlur="{(e) => {
                copiedFilter.textSearch = e.target.value
            }}"
            onChange="{() => {}}"
        />
    </div>
</div>

<style lang="less">
    @import "../../../assets/variables.less";
    .filter-row {
        display: flex;
        justify-content: space-between;
        gap: 0.6rem;
        width: 100%;
        padding: 1.2rem;
        @media @mobile {
            display: grid;
            grid-template-columns: 1fr;
            & > div {
                min-width: 100%;
                width: 100%;
                max-width: 40vw;
            }
            padding: 0px 1.2rem;
            padding-bottom: 0.6rem;
        }
        & > div {
            flex: 1;
        }
    }
</style>
